import './transfer.scss';
import * as React from 'react';
import { bindActionCreators } from 'redux';
import { RootState, Dispatch } from '@src/app/_redux';
import { connect } from 'react-redux';
import { Field, reduxForm, formValueSelector  } from 'redux-form';
import { Row, Col, Container } from 'reactstrap';
import { OrderUpdatePayload } from '@src/_api/payload';
import { FormattedMessage, intlShape } from 'react-intl';
import { actionCreators } from '@src/app/accounts/orders/actions';
import { actionCreators as promoInquiryActionCreators } from '@src/app/accounts/renewals/actions';
import { LoadingView } from '@src/app/_global/components/Loading';
import { ResponseView } from '../../transfer/components/ResponseView';
import { getOrderById } from '../../redux/selectors';
import { getCustomerByOrderId } from '../../selectors';
import { withRouter } from 'react-router';
import { SimplerSelectV2, RadioButtons } from '@src/app/_global/components/form-elements';
import { getAdminConfigTableItem } from '@src/app/_global/utility/adminConfigUtils';
import { selectRequired } from '@src/app/_global/field-validations';

export interface TransferProps {
  adminConfig: any;
  clientConfig: any;
  history: any;
  orderUpdateCancel: any;
  promoCodeInqStart: any;
  promoCodeInqCancel: any;
  location: any;
  currentOrder: any;
  accountNumber: any;
  handleSubmit: any;
  error: any;
  submitting: any;
  orderUpdateData: any;
  renewalsData: any;
  customer: any;
  orderUpdate: any;
  transferSubValue: any;
}
export class Form extends React.Component<TransferProps> {
  history: any = this.props.history;
  state: any = {
    currentView: '',
  };

  componentWillMount() {
    // if CORE, call to get the 'MIGRATE' promotion
    if (this.props.currentOrder.systemCode === 'CORE') {
      let promotionCodes = [{promotionKey: 'MIGRATE'}];
      this.props.promoCodeInqStart({'promoCodeInqOrders': promotionCodes, 'customer': this.props.customer});
    }
  }

  componentDidMount() {
    this.props.orderUpdateCancel();
    let currentView = this.props.location.pathname.split('/')[2];
    this.setState({currentView: currentView});
  }
  // tslint:disable-next-line:member-ordering
  static contextTypes = {
    intl: intlShape,
  };

  // format table heading labels for i18n
  formatLabels = (messageId, descriptionM, defaultM, context) => {
    const labelText = context.intl.formatMessage({
      id: messageId,
      description: descriptionM,
      defaultMessage: defaultM,
    });
    return labelText;
  }

  // tslint:disable-next-line:member-ordering
  transferHeadingLabel = this.formatLabels(
    'transfer.heading',
    'heading transfer',
    'Transfer Subscription',
    this.context,
  );

  // tslint:disable-next-line:member-ordering
  subscriptionSelectionTitle = this.formatLabels(
    'transfer.selection',
    'heading selection',
    'Select Your New Subscription',
    this.context,
  );

  handleCancel = () => {
    this.props.orderUpdateCancel();
    this.props.promoCodeInqCancel();
    this.history.push('/accounts/summary');
  }
  getTransferSubs () {
    const { adminConfig, clientConfig, currentOrder, renewalsData } = this.props;
    let tableName = 'ClientProperties';
    let globalCode = clientConfig.clientConfig.globalCode;
    let transferSubs = new Array();
    let orderClientCode = adminConfig.adminConfig[currentOrder.prodIdAlias][tableName].ClientCode;
    Object.keys(adminConfig.adminConfig).map(prodIdAlias  => {
      let config = adminConfig.adminConfig[prodIdAlias][tableName];
      if (config.GlobalCode === globalCode 
        && config.ProdId !== '*' 
        && (config.ProductType === 'SERV' || config.ProductType === 'Core')
        && currentOrder.prodIdAlias !== config.ProdId
        && orderClientCode === config.ClientCode) {
          let availableActions = getAdminConfigTableItem(
            this.props.adminConfig,
            this.props.clientConfig,
            'AvailableActions',
            config.ProdId
          );
          if (availableActions && availableActions.Preferences 
              && availableActions.Preferences.enableTransfer === true) {
            if (config.ProductType === 'Core') {
              if (renewalsData.promoCodeInqResult) {
                let promotion = renewalsData.promoCodeInqResult.promotionCodes.find((promoCode) => 
                  'MIGRATE' === promoCode.promotionCode
                );
                if (promotion && promotion.products.length > 0) {
                  let promotionProduct = promotion.products.find((product) => 
                    config.ProdId === product.itemNumber && product.productType === 'Subscription'
                  );
                  if (promotionProduct && promotionProduct.choices && promotionProduct.choices.length > 0) {
                    transferSubs.push({
                      prodIdAlias: config.ProdId,
                      productName: promotionProduct.name,
                      id: config.ProdId,
                      image: availableActions.Preferences.transferImage,
                      label: promotionProduct.name,
                      value: config.ProdId,
                      itemNumber: promotionProduct.itemNumber,
                      choiceCode: (promotionProduct.choices[0].choiceCode || ''),
                    });
                  }
                }
              }
            } else {
              transferSubs.push({
                prodIdAlias: config.ProdId,
                productName: config.ProductName,
                id: config.ProdId,
                image: availableActions.Preferences.transferImage,
                label: config.ProductName,
                value: config.ProdId
              });
            }
          }
      }
    });
    return transferSubs.sort(function(a: any, b: any) {
      if (a.productName > b.productName) { 
          return 1;
      } 
      if (a.productName < b.productName) {
          return -1;
      }
      return 0;
    });
  }
  onSaveClick(values: any) {
    const { currentOrder, accountNumber, customer } = this.props;
    let payload: OrderUpdatePayload;
    let transferSub = values.transfersub.value ? values.transfersub.value : values.transfersub;

    if (currentOrder.systemCode === 'CORE') {
      let transferSubs = this.getTransferSubs();
      let selectedSub = transferSubs.find((sub) => sub.value === transferSub);
      payload = {
        prodIdAlias: customer.prodIdAlias,
        accountNumber: accountNumber ? accountNumber : currentOrder.billToAccountNumber ,
        googleAnalyticsCategory: 'Subscription Transfer',
        googleAnalyticsLabel: currentOrder.prodIdAlias,
        systemCode: currentOrder.systemCode,
        coreTransactionType: 'migrate',
        toMagAbbr: transferSub,
        currentProductName: currentOrder.productName,
        newProductName: selectedSub.productName,
        entityId: currentOrder.entityId,
        entityType: currentOrder.entityType,
        promotionCode: 'MIGRATE',
        choiceCode: selectedSub.choiceCode,
        isImmediateUpdate: true,
        isNewOrderProrated: true,
        itemNumber: selectedSub.itemNumber,
        quantity: currentOrder.orderItems.length > 0 ? currentOrder.orderItems[0].quantity : '1',
      };
    } else {
      let giftSetValue = '';
      let movesw = '';
      let toService = '';
      if (currentOrder.isDonor && currentOrder.billToAccountNumber === accountNumber) {
        // subscribing donor from my subs send N so we don't transfer the entire gift set
        giftSetValue = 'N';
        movesw = '2';
      } else {
        giftSetValue = 'Y';
      }
      let availableActions = getAdminConfigTableItem(
        this.props.adminConfig,
        this.props.clientConfig,
        'AvailableActions',
        transferSub
      );
      if (currentOrder.orderEntryDescription === 'Credit' && currentOrder.amountDue !== '0.00') {
        toService = 'F';
      } else {
        toService = 'R';
      }
      var toDocumentKey = availableActions.Preferences.transferPromotionKey ? availableActions.Preferences.transferPromotionKey : '';
      
      let tableName = 'ClientProperties';
      let newProductName = this.props.adminConfig.adminConfig[transferSub][tableName].ProductName;

      payload = {
        prodIdAlias: currentOrder.prodIdAlias,
        accountNumber: accountNumber ? accountNumber : currentOrder.billToAccountNumber ,
        googleAnalyticsCategory: 'Subscription Transfer',
        migration: 'Y',
        toMagAbbr: transferSub,
        giftSet: giftSetValue,
        moveSw: movesw,
        currentProductName: currentOrder.productName,
        newProductName: newProductName,
        toService: toService,
        orderNumber: currentOrder.orderNumber,
        toDocKey: toDocumentKey.toUpperCase(),
      };
    }
    this.props.orderUpdate([payload]);
  }

  render() {
    const {
      handleSubmit,
      error,
      submitting,
      currentOrder,
      orderUpdateData,
      renewalsData,
      customer,
      adminConfig,
      clientConfig,
      transferSubValue,
    } = this.props;

    let transferSubs = this.getTransferSubs();
    let aa = getAdminConfigTableItem(this.props.adminConfig, this.props.clientConfig,
      'AvailableActions', currentOrder.prodIdAlias);
    let overrideHeading = aa && aa.Preferences && aa.Preferences.customTransferLabel ? 
        aa.Preferences.customTransferLabel : this.transferHeadingLabel;

    return (
      
      <div>
        <header className="page-header mb-2">
          <span>
            {overrideHeading}
          </span>
        </header>
        <Container className="resume-ct" tabIndex={0} fluid={true}>
      
      { renewalsData.promoCodeInqLoading || orderUpdateData.loading ? (
        <LoadingView loadingText="Loading..."/>
      ) : (
        orderUpdateData.orderUpdateResult !== null ? (
        <ResponseView
          response={orderUpdateData.orderUpdateResult}
          onExit={this.handleCancel}
          adminConfig={adminConfig}
          clientConfig={clientConfig}
          customer={customer}
          oldProductName={orderUpdateData.orderUpdateResult.success ? orderUpdateData.orderUpdateResult.accountResponse[0].currentProductName : ''}
          newProductName={orderUpdateData.orderUpdateResult.success ? orderUpdateData.orderUpdateResult.accountResponse[0].newProductName : ''}
          availableActions={aa}
          currentOrder={currentOrder}
        />
      ) : (
        <form onSubmit={handleSubmit(fields => this.onSaveClick(fields))}>
          <div className="transfer">
            <Row>
              <Col xs={12} sm={12} md={12}>
                <div>
                  <span className="transfer-text-current mt-2"><strong>Current Subscription:</strong> {currentOrder.productName}</span>
                </div>
              </Col>
            </Row>
            <Row>
              <Col xs={12} sm={12} md={12}>
                <div className="mb-2 mt-2">
                  <span className="transfer-text">{this.subscriptionSelectionTitle}</span>
                </div>
              </Col>
            </Row>
            {transferSubs[0] && !transferSubs[0].image && (
              <Row>
                <Col xs={12} sm={12} md={6}>
                  <div>
                  <Field
                    name={'transfersub'}
                    label="To Subscription"
                    valueKey="prodIdAlias"
                    labelKey="productName"
                    component={SimplerSelectV2}
                    options={transferSubs}
                    validate={[selectRequired]}
                    ariaLabel="To Subscription"
                    placeholder="To Subscription"
                    searchable="true"
                    defaultOption={transferSubValue}
                  />
                  </div>
                </Col>
              </Row>
            )}
            {transferSubs[0] && transferSubs[0].image && (
              <Row>
                <Col xs={12} sm={12} md={6}>
                  <RadioButtons
                    className="vertical"
                    name="transfersub"
                    options={transferSubs}
                  />
                </Col>
              </Row>
            )}
            <Row>
              <Col xs={12} sm={12} md={12}>
                <div className="notification-ct">
                  {error && <strong>{error}</strong>}
                </div>
                <div className="button-ct">
                  <button
                    className="btn btn-primary"
                    type="submit"
                    disabled={submitting || !transferSubValue}
                  >
                    <FormattedMessage
                      id="transfer.submit"
                      description="heading transfer button"
                      defaultMessage="Save"
                    />
                  </button>
                  <button
                    className="btn btn-light ml-2"
                    type="button"
                    onClick={this.handleCancel}
                  >
                    <FormattedMessage
                      id="app.cancel"
                      description="heading cancel button"
                      defaultMessage="Cancel"
                    />
                  </button>
                </div>
              </Col>
            </Row>
          </div>
        </form>
        )
      )}
      </Container>
      </div>
    );
  }
}

const TransferForm = reduxForm({
  form: 'transfer-form',
  forceUnregisterOnUnmount: true,
})(Form);
const selector = formValueSelector( 'transfer-form');
const mapStateToProps = (state: RootState, props) => {
  const currentOrder = getOrderById(state, props.match.params.orderNumber);
  const accountNumber = props.match.params.accountNumber;
  return {
    currentOrder: currentOrder,
    accountNumber: accountNumber,
    customer: getCustomerByOrderId(state, props.match.params.orderNumber),
    clientConfig: state.clientConfig,
    adminConfig: state.adminConfig,
    orderUpdateData: state.account.orderData,
    renewalsData: state.account.renewalsData,
    currentView: props.currentView,
    transferSubValue: selector(state, 'transfersub'),
  };
};

const mapDispatchToProps = (dispatch: Dispatch) =>
  bindActionCreators(
    {
      orderUpdate: actionCreators.orderUpdateStart,
      orderUpdateCancel: actionCreators.orderUpdateCancel,
      promoCodeInqStart: promoInquiryActionCreators.promoCodeInqStart,
      promoCodeInqCancel: promoInquiryActionCreators.promoCodeInqCancel,
    },
    dispatch,
  );

export default withRouter(connect(
  mapStateToProps,
  mapDispatchToProps,
)(TransferForm));
